import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { axiosInstance } from '../../config/axios';

export interface IGetPasswordSettingsRequest {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
}

async function getPasswordSettings(data: IGetPasswordSettingsRequest): Promise<any> {
  try {
    return (await axiosInstance.post("/Setting/List", {
      ...data,
      groupCode: "PASSWORD"
    })).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetPasswordSettings() {
  const queryData: IGetPasswordSettingsRequest = {
    page: 1,
    size: 50,
    orderByDesc: true,
    orderBy: "CreateDate"
  };

  return useQuery<any, Error>('passwordSettings', () => getPasswordSettings(queryData));
}
